<template>
    <div class="select" style="position: relative" :aria-busy="isLoading">
        <select v-model="model" @change="$emit('change', model)" :disabled="disabled">
            <option :value="null">---</option>
            <option v-for="federationRole in selectableRoles" :key="federationRole" :value="federationRole">
                {{ translateFederationRole(federationRole) }}
            </option>
        </select>
        <div v-if="isLoading" class="loading-overlay">
            <i class="fa fa-spinner fa-spin"></i>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { FederationRole, FederationRoleEnum, translateFederationRole } from "../../Api/federationsApi";

    const model = defineModel<FederationRole | null>({
        default: null,
    });

    defineEmits(["change"]);

    const props = defineProps<{ isLoading?: boolean; disabled?: boolean; excludeRoles?: FederationRole[] }>();

    const selectableRoles = computed(() => Object.values(FederationRoleEnum).filter(role => !(props.excludeRoles ?? []).includes(role)));
</script>

<style scoped>
    .loading-overlay {
        position: absolute;
        top: 0;
        color: black;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        pointer-events: all;
        cursor: progress;
        backdrop-filter: blur(2px);
        -webkit-backdrop-filter: blur(2px);
    }
    .select[aria-busy="true"] select:hover {
        cursor: progress;
    }
</style>
